import { ProDocReview } from '@fiveox/prodoc-ui'
import { PageHeader, buttonClass } from '@fiveox/ui'
import { Link, useNavigate, useSearchParams } from 'react-router'

import { useOrg } from '../components/org-context'
import { SERVICE_API } from '../lib/config'
import { session } from '../lib/session'

/**
 * Review — the documents waiting for a person's decision. A thin host
 * (ADR-0010): the screen is `<ProDocReview>`, which takes the shell's fetcher
 * and the selected org and knows nothing of this app. What the route adds is
 * **the URL** — the open document is `?doc=`, so a document in review can be
 * linked to, and the browser's back button leaves it — and the way to a
 * document's own screen.
 *
 * Routed behind `can_update` on `document` (`router.tsx`): a reader without it
 * is redirected to Overview rather than shown an empty page.
 */
export function ReviewPage() {
  const { org, userId } = useOrg()
  const navigate = useNavigate()
  const [params, setParams] = useSearchParams()
  const selected = params.get('doc')

  return (
    <div className="space-y-6">
      <PageHeader
        title="Review"
        description={
          selected
            ? undefined
            : 'Documents waiting for a decision, oldest first. Check each against its file, then approve or reject it — whoever uploaded it is told.'
        }
      />
      <ProDocReview
        apiUrl={SERVICE_API}
        fetcher={session.authed}
        orgId={org.id}
        userId={userId}
        documentId={selected}
        onSelect={(id) => {
          setParams(id ? { doc: id } : {}, { replace: true })
          window.scrollTo({ top: 0 })
        }}
        onOpenDocument={(doc) => navigate(`/documents/${doc.id}`)}
        emptyAction={
          <Link to="/documents" className={buttonClass({ variant: 'outline' })}>
            Open documents
          </Link>
        }
      />
    </div>
  )
}
